// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"e68da74d","130":"8b1b79f7","367":"8066f14c","817":"e8406ef4"}[chunkId] + ".css";
};